(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("intersection-observer"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "intersection-observer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("intersection-observer")) : factory(root["react"], root["intersection-observer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 